













// vendor
import { defineComponent, computed, ref } from "@vue/composition-api";
// project
import * as AppModal from "@/AppModal";
import { ContextOption } from "@/components.generic/context-menu";
import { camelToSentenceCase } from "@/utils/text";
// local
import { templates } from "../../ts/HTMLTemplates";
import { default as TemplateModal } from "./html-template-modal.vue";

export default defineComponent({

	emits:[
		"confirm"
	],
	components:{
		TemplateModal
	},
	setup(props, context){

		const templateModal = ref<any>();

		const selectOption = (templateName:string) => {
			if(!templateModal.value){ return; }
			templateModal.value.open(templateName, (result:string) => {
				context.emit("confirm", result);
			});
		};
		
		const getOptions = ():ContextOption[] => {
			
			return Object.keys(templates)
			.map(tk => ({
				name:camelToSentenceCase(tk),
				icon: templates[tk].icon || "mdi.code-tags",
				fn(){
					selectOption(tk);
				}
			}));
		};

		const press = (e:Event) => {
			AppModal.context(e, getOptions());
		};

		return {
			press,
			templateModal,
		};
	}
});

